<script>

    import { toast } from 'bulma-toast'
    import { shipmentStore, shipmentsStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import ShipmentsService from '../$services/shipments.service'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import OrderPackage from '../orders/component.package.svelte'
    import OrderLocation from '../orders/component.location.svelte'

    import ButtonDelete from '../$components/button.delete.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'
    import InfoTag from '../$components/info.tag.svelte'

    let loading = false

    async function cancelShipment(refund) {

        loading = true
        const resp = await ShipmentsService.cancelShipment($shipmentStore._id, refund)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        shipmentStore.set(resp.data)
        shipmentsStore.replace(resp.data)

        if(refund)
            return toast({message: 'Guía reembolsada', type: 'is-success'})

        toast({message: 'Guía cancelada', type: 'is-success'})
    }

</script>

<InfoCard subtitle="Detalle del envío" title={ $shipmentStore.provider }>
    <span slot="tag">
        <InfoTag color="info" icon="fas fa-shipping-fast" label={ $shipmentStore.trackingStatus || 'Sin estatus' } />
    </span>
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        <InfoField label="Partner" icon="fas fa-handshake" value={ $shipmentStore.partner || 'logisbox' } />
        <InfoField label="Servicio" icon="fas fa-box" value={ $shipmentStore.service } bold />
        <InfoField label="Código" icon="fas fa-hashtag" value={ $shipmentStore.code } />
        <InfoField label="Guía" icon="fas fa-barcode" value={ $shipmentStore.guide } bold />
        <InfoField label="Rastreo" icon="fas fa-search-location" value={ $shipmentStore.trackingNumber || 'Sin número' } />
        <InfoField label="Tienda" icon="fas fa-store" value={ $shipmentStore.order.storeType } />
        <InfoField label="Núm. orden" icon="fas fa-hashtag" value={ $shipmentStore.order.number } />
        <InfoField label="Peso vol." icon="fas fa-weight" value="{ $shipmentStore.order.package.volumetric } Kg" />
        <InfoField label="Creación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($shipmentStore.created) } />
    </div>
    <div class="items-end mb-0">
        <div class="buttons">
            <a class="button" href="{ $shipmentStore.document }" target="_blank" rel="noopener noreferrer">
                <span class="icon"><i class="fas fa-file-pdf"></i></span>
                <span>Guía PDF</span>
            </a>
        </div>
    </div>
</InfoCard>

<InfoCard subtitle="Precios">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        <InfoField label="Precio final" icon="fas fa-dollar-sign" value={ NumeralMethods.cash($shipmentStore.pricing.finalPrice) } bold color="success" />
        <InfoField label="Costo envío" icon="fas fa-truck" value={ NumeralMethods.cash($shipmentStore.pricing.shipmentCost) } />
        <InfoField label="Precio envío" icon="fas fa-tag" value={ NumeralMethods.cash($shipmentStore.pricing.shipmentPrice) } />
        <InfoField label="Seguro" icon="fas fa-shield-alt" value={ NumeralMethods.cash($shipmentStore.pricing.insurancePrice) } />
        <InfoField label="Extra" icon="fas fa-plus-circle" value={ NumeralMethods.cash($shipmentStore.pricing.aggregatePrice) } />
        <InfoField label="Tipo de pago" icon="fas fa-wallet" value={ TranslateMethods.get($shipmentStore.pricing.paymentType) } />
    </div>
</InfoCard>

<InfoCard subtitle="Cliente">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        <InfoField label="Nombre" icon="fas fa-user" value={ $shipmentStore.user.name } bold />
        <InfoField label="Correo" icon="fas fa-envelope" value={ $shipmentStore.user.email } />
    </div>
</InfoCard>

<OrderPackage />
<OrderLocation title="Origen" location={ $shipmentStore.order.pickup } />
<OrderLocation title="Destino" location={ $shipmentStore.order.delivery } />

{#if isPermission($adminStore, 'ShipmentsView.Shipment.Cancel')}
    <div class="columns mt-4">
        <div class="column">
            <ButtonDelete on:confirm={() => cancelShipment(true)} text="Reembolsar" { loading } fullwidth />
        </div>
        <div class="column">
            <ButtonDelete on:confirm={cancelShipment} text="Cancelar" { loading } fullwidth />
        </div>
    </div>
{/if}
